// Perfis que acessam a Agenda (rota e atalhos que a reutilizam, como a agenda do dia
// na lateral da conversa). A visibilidade dos agendamentos do Talkvia Studio é
// aplicada pela API: agentes recebem só os seus; administradores, os da conta.
export const CALENDAR_ROUTE_PERMISSIONS = Object.freeze([
  'administrator',
  'agent',
  'custom_role',
]);
